import { module } from 'modujs';
import { queryClosestParent } from '../utils/html';
import { gsap } from 'gsap/all'
import Raf from 'quark-raf'

function easeOutQuart(x) {
    return 1 - Math.pow(1 - x, 4);
}

export default class extends module {
    constructor(m) {
        super(m);

        this.lazyloaded = false;
    }

    init() {
        this.content = this.$('content')[0]

        this.updateBind = this.update.bind(this)
    }

    enter() {
        this.lazyLoad();
        this.el.classList.add('is-inview')
        if(window.innerWidth < 1000) return;
        Raf.add(this.updateBind);
    }

    leave() {
        this.el.classList.remove('is-inview')
        if(window.innerWidth < 1000) return;
        Raf.remove(this.updateBind);
    }

    update() {
        if(!this.content) return

        // const BCR = this.el.getBoundingClientRect();

        // const largestDistance = Math.sqrt(Math.pow(-window.innerWidth/2,2) + Math.pow(-window.innerHeight/2,2))
        // const distanceFromCenter = Math.sqrt(Math.pow((BCR.left+BCR.width/2) - window.innerWidth/2,2) + Math.pow((BCR.top+BCR.height/2) - window.innerHeight/2,2));

        // let progress = (largestDistance - distanceFromCenter)/largestDistance;
        // progress = Math.max(0,Math.min(1,progress));

        // const containerX = (BCR.left+BCR.width/2)/window.innerWidth;
        // const containerY = (BCR.top+BCR.height/2)/window.innerHeight;

        // gsap.set(this.content, {
        //     scale: 0.5 + 0.5 * easeOutQuart(progress),
        //     transformOrigin: `${containerX*100}% ${containerY*100}%`
        // })

        // const progressX = ((window.innerWidth/2) - (BCR.left+BCR.width/2)) / (window.innerWidth/2)
        // const progressY = ((window.innerHeight/2) - (BCR.top+BCR.height/2)) / (window.innerHeight/2)

        // this.el.setAttribute('progress', `${progressX}`)

        // gsap.set(this.content, {
            // scale: 0.5 + 0.5 * easeOutQuart(progress),
            // transformOrigin: `${containerX*100}% ${containerY*100}%`
            // x: `${progressX*-25}%`,
            // y: `${progressY*-5}%`
        // })
    }

    lazyLoad() {
        if(this.lazyloaded) return
        this.lazyloaded = true

        let images = Array.from(this.$('lazy'));

        for(let el of images) {
            let src = el.getAttribute('data-lazy-src')

            if(src.length) {
                let img = new Image()

                let loadCallback = () => {
                    if(el.tagName == "IMG") {
                        el.src = src
                    } else {
                        el.style.backgroundImage = `url(${src})`
                    }

                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            let lazyParent = queryClosestParent(el, '.o-lazy_wrapper')
                            if(lazyParent) lazyParent.classList.add('is-loaded')
                            el.classList.add('is-loaded')
                        })
                    })
                }

                // Try to use `decode` if available (to prevent jank), otherwise use the standard `onload`
                if(img.decode) {
                    img.src = src
                    img.decode().then(loadCallback).catch(err => {
                        console.error(err)
                    })
                } else {
                    img.onload = loadCallback
                    img.src = src
                }
            }
        }
    }

    destroy() {
        Raf.remove(this.updateBind);
    }
}
